<h2 mat-dialog-title>User Defined Fields</h2>

<mat-dialog-content fxFlex="auto">
  @if (!isLoaded) {
    <forge-circular-progress></forge-circular-progress>
  }

  @if (isLoaded) {
    @if (isEmpty) {
      <div fxLayout="column" fxLayoutAlign="center center">
        <div fxLayout="column" fxLayoutAlign="center center">
          <img alt="Illustration of a clipboard, pen, envelope, and sticky notes" src="https://cdn.forge.tylertech.com/v1/images/spot-hero/setup-1-empty-state-spot-hero.svg">
          <div class="forge-typography--heading2">There are no fields defined.</div>
        </div>
      </div>
    }
    @if (!isEmpty) {
      <forge-card fxLayoutAlign="start center" telemetry="Card-UserDefinedFields">
        <div fxLayout="row">
          @for (field of activeUserDefinedFields; track field) {
            <div fxFlex.gt-md="25" fxFlex.md="33" fxFlex="50">
              <user-defined-field [field]="field" [viewOnly]="viewOnly">
              </user-defined-field>
            </div>
          }
        </div>
      </forge-card>
    }
  }
</mat-dialog-content>

<mat-dialog-actions fxLayoutAlign="end start">
  <command-bar [commands]="commands" telemetry="CmdBar-CommandKey-UserDefinedFields">
  </command-bar>
</mat-dialog-actions>